


















import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  CURRENT_POSITION,
  CURRENT_RECORDING,
  IS_PLAYING,
  RECORDING_DURATION,
  SET_CURRENT_POSITION,
  SET_REQUESTED_POSITION,
  REQUESTED_POSITION
} from '@/store';

const convertTimeHHMMSS = (val: number) => {
  let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
  return hhmmss.indexOf('00:') === 0 ? hhmmss.substr(3) : hhmmss;
};

@Component
export default class AudioPlaybackSlider extends Vue {
  @Prop({ required: true }) id!: string;

  get duration() {
    return this.$store.getters[RECORDING_DURATION](this.id);
  }

  get currentRecording() {
    return this.$store.getters[CURRENT_RECORDING];
  }

  get playerCurrentPosition() {
    return this.$store.getters[CURRENT_POSITION];
  }

  get playerRequestedPosition() {
    return this.$store.getters[REQUESTED_POSITION];
  }

  get isPlaying() {
    return this.$store.getters[IS_PLAYING];
  }

  get durationDisplay() {
    return this.duration ? convertTimeHHMMSS(this.duration) : '';
  }

  get recordingActive() {
    return this.currentRecording === this.id;
  }

  get allowSeek() {
    return !this.isPlaying || this.currentRecording === this.id;
  }

  get currentPosition() {
    return this.recordingActive ? this.playerCurrentPosition : 0;
  }

  get currentPositionDisplay() {
    return this.currentPosition ? convertTimeHHMMSS(this.currentPosition) : '00:00';
  }

  get tooltip() {
    return () => this.currentPositionDisplay;
  }

  handleChange(value: number) {
    this.$store.commit(SET_REQUESTED_POSITION, value);
  }
}
